import React from 'react';
import IntersectionVisible from '../../../../../IntersectionVisible';
export const IntersectContainer = ({ children, className, onShow, isActive, }) => {
    if (onShow) {
        return (React.createElement(IntersectionVisible, { onShow: onShow, className: className, options: { threshold: 0.75 }, isActive: isActive }, children));
    }
    return React.createElement("div", { className: className }, children);
};
//# sourceMappingURL=IntersectContainer.js.map